import React, { useState } from 'react';

import { mdiDotsHorizontal } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';

import SnapshotTileMenu from './SnapshotTileMenu';

const MenuIcon = styled.div<{ onClick }>`
    display: flex;
    align-items: center;
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 2px 10px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.primary.main};
    cursor: pointer;
    z-index: 2;
    
    svg {
        width: 24px;
        color: ${(props) => props.theme.colors.white};
    }
`;

export interface VideoTileControlsProps {
    breakoutName: string;
}

const SnapshotTileControls: React.FC<VideoTileControlsProps> = ({ breakoutName }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <MenuIcon onClick={handleClick}><Icon path={mdiDotsHorizontal} /></MenuIcon>
            <SnapshotTileMenu breakoutName={breakoutName} anchorEl={anchorEl} onClose={handleClose} />
        </>
    );
};

export default SnapshotTileControls;
